import { DateTime } from "luxon";
import { RangeCriteria, RangeFilterChangeFunction } from "../generic/RangeColumnDefinition";
import { DateRangeColumnDefinition, dateRangeFilter } from "../generic/DateRangeColumnDefinition";
import { ExpirationDateTimeComponent } from "@goodfill/domain-properties-components";
import { TIMEZONE_NEY_YORK } from "../../../locale/timezone";

export const EXPIRES_AT_DATE_CRITERIA_KEY = "expiresAt";

export const expiresAtDateFilter = <TItemKey extends string>(key: TItemKey) =>
  dateRangeFilter(EXPIRES_AT_DATE_CRITERIA_KEY, key, TIMEZONE_NEY_YORK);

export const ExpiresAtDateColumnDefinition = <TItemKey extends string>(
  key: TItemKey,
  criteria: RangeCriteria<typeof EXPIRES_AT_DATE_CRITERIA_KEY, DateTime>,
  onFilterChange: RangeFilterChangeFunction<typeof EXPIRES_AT_DATE_CRITERIA_KEY, DateTime>,
) =>
  DateRangeColumnDefinition("Expiry Date", key, EXPIRES_AT_DATE_CRITERIA_KEY, criteria, onFilterChange, (item) => (
    <ExpirationDateTimeComponent value={item[key]} timezone={TIMEZONE_NEY_YORK} />
  ));
